import { TemplateResult, LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import encapsulatedStyles from './styles/outline-mobile-menu.encapsulated.pcss?inline';
import globalStyles from './styles/outline-mobile-menu.global.pcss?inline';
import { classMap } from 'lit/directives/class-map.js';
import './../outline-svg/outline-svg';

/**
 * Outline Mobile Menu component
 *
 * @slot - The mobile menu items
 */

@customElement('outline-mobile-menu')
export class OutlineMobileMenu extends LitElement {

  @property({ type: Boolean, attribute: 'open' })
  open: boolean;

  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    encapsulatedCSS: encapsulatedStyles,
    globalCSS: globalStyles,
  });

  handleToggleMenu() {
    this.open = !this.open;
  }

  render(): TemplateResult {
    const menuClasses = {
      'mobile-menu': true,
      'open': this.open,
    };

    return html`
      <div class="${classMap(menuClasses)}">
        <div class="menu">
          <button @click=${this.handleToggleMenu}>
            <span class="label">
              <slot name="icon"></slot>
              <slot name="label"></slot>
            </span>
            <outline-svg
              slot="icon"
              name="${this.open ? 'chevronUp' : 'chevronDown'}"
              size="30px"
              svg-fill="var(--bjc-nav-blue)"
            ></outline-svg>
          </button>
        </div>
        <div class="menu-content">
          <slot></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-mobile-menu': OutlineMobileMenu;
  }
}
